<template>
    <div style="width: 100%;">
        <div class="d-flex col-12">
            <div class="form-control-label" style="white-space: pre-line;margin-left: 4px;"><span v-if="question.is_required" class="required-star mr-1">*</span>{{title}}</div>
        </div>
        <div class="col-12" v-if="question.image_file_name">
            <img class="cursor-pointer" :src="this.context.storageEndpoint + this.question.image_file_name" @click="openPhotoViewer = true"/>
        </div>
        <div class="col-12"><p class="text-muted px-1 question-description" v-html="formattedText"></p></div>
        <div v-if="!hasValidAnswer && showInvalid"
            class="col-12 pl-3">
            <div class="alert alert-warning">{{$t('message.please_fill_your_answer')}}</div>
        </div>
        <div class="col-12">
            <div v-if="formLayout === 'horizontal'">
                <div class="d-flex align-items-center justify-content-center mb-2">
                    <span v-if="content.data.min_label" class="invisible">{{ content.data.min_label }}</span>
                    <div class="mx-3 d-flex align-items-center justify-content-around flex-grow-1">
                        <div v-for="scale in scaleOptions" :key="scale" class="tickbox-label">
                            {{ scale }}
                        </div>
                    </div>
                    <span v-if="content.data.max_label" class="invisible">{{ content.data.max_label }}</span>
                </div>
                <div class="d-flex align-items-center justify-content-center pb-4">
                    <span v-if="content.data.min_label" ref="min-label">{{ content.data.min_label }}</span>
                    <div class="mx-3 d-flex align-items-center justify-content-around flex-grow-1">
                        <input v-for="scale in scaleOptions" :key="scale" type="radio" :name="`linear-scale-${id}`" v-model="selectedScale" :value="scale">
                    </div>
                    <span v-if="content.data.max_label">{{ content.data.max_label }}</span>
                </div>
            </div>
            <div v-else>
                <div class="d-flex flex-column align-items-start justify-content-center pb-4">
                    <span v-if="content.data.min_label" ref="min-label">{{ content.data.min_label }}</span>
                    <div class="my-2">
                        <div v-for="scale in scaleOptions" :key="scale" class="d-flex align-items-center mb-2">
                            <input type="radio" :name="`linear-scale-${id}`" v-model="selectedScale" :value="scale">
                            <div class="tickbox-label">{{ scale }}</div>
                        </div>
                    </div>
                    <span v-if="content.data.max_label">{{ content.data.max_label }}</span>
                </div>
            </div>
            <div class="text-right my-3 link-clear-selected">
                <a href="javascript:void(0)" @click.prevent="clearSelectedScale">{{$t('clear_selected')}}</a>
            </div>
        </div>
        <photo-viewer
            v-if="openPhotoViewer"
            ref="photoViewer"
            :photos="photo"
            :context="context"
            @close="openPhotoViewer = false"></photo-viewer>
    </div>
</template>

<script>
import Constants from '../../constants';
import PhotoViewer from '../common/PhotoViewer.vue';

export default {
    components: { PhotoViewer },
    props: ['question', 'providerId', 'context', 'answer'],
    data() {
        const content = this.question.content;
        let scaleOptions = [];
        const minScale = content.data.min_scale;
        const maxScale = content.data.max_scale;

        for (let i=minScale;i<=maxScale;i++) {
            scaleOptions.push(i);
        }

        const selectedScale = this.answer?.parsedContent?.scale;
        if ((selectedScale === 0 || selectedScale) && (selectedScale < minScale || selectedScale > maxScale)) {
            scaleOptions.push(selectedScale);
        }
        scaleOptions.sort((a, b) => a - b);

        scaleOptions.sort((a, b) => a - b);

        return {
            id: this.question.id,
            content,
            status: this.question.status,
            adminQuestion: this.question.question,
            Constants,
            showInvalid: false,
            selectedScale,
            scaleOptions,
            openPhotoViewer: false,
            formLayout: 'horizontal', // horizontal | vertical
        };
    },
    computed: {
        title: function() {
            return this.content.meta.title || '';
        },

        photo() {
            if (this.question.image_file_name) {
                return [{
                    path: this.question.image_file_name
                }];
            } else {
                return [];
            }
        },

        hasAnswer() {
            return this.selectedScale === 0 || !!this.selectedScale;
        },

        hasValidAnswer() {
            return this.selectedScale === 0 || !!this.selectedScale;
        },

        formattedText() {
            const text = this.content.data.text;
            return text?.nl2brIfNotHTML() || '';
        }
    },
    mounted() {
        if (this.$refs['min-label']) {
            var resizeObserver = new ResizeObserver(entries => {
                const $minLabelEl = entries[0].target;
                const $parentEl = $minLabelEl.parentNode;
                const minLabelRect = $minLabelEl.getBoundingClientRect();
                const parentRect = $parentEl.getBoundingClientRect();
                if (minLabelRect.x < parentRect.x) {
                    this.formLayout = 'vertical';
                }
            });
            resizeObserver.observe(this.$refs['min-label']);
        }
    },
    methods: {
        clearSelectedScale() {
            this.selectedScale = null;
        },

        highlightInvalidState() {
            this.showInvalid = true;
        },

        getDataToPersist() {
            return {
                question_id: this.id,
                answer: {
                    scale: this.selectedScale
                },
                answer_id: this.answer ? this.answer.id : null
            };
        }
    }
}
</script>

<style scoped>
.required-star {
    color: red;
    font-weight: bold;
}

textarea {
    margin: 1em auto;
    width: 96%;
}

img {
    max-width: max-content;
    width: 100%;
    border-radius: 4px;
}

.link-clear-selected {
    font-size: 0.875rem;
}

input[type=radio] {
    width: 16px;
    height: 16px;
    margin: 4px;
    display: inline-block;
}

.tickbox-label {
    min-width: 24px;
    text-align: center;
}

</style>

<i18n>
{
    "en": {
        "clear_selected": "Clear selected item"
    },
    "zh": {
        "clear_selected": "清除選取的項目"
    }
}
</i18n>